define(
            'mustache!/home/circleci/project/msproblem/static/jsmvc/learn/signup_video/signup_video.mustache',
            ['can/util/library', 'can/view/mustache'],
          function(can) { 
            var template = '<uc-modal-video title="Mathspace Learn" aspect-169="true" header-height="0" custom-height-ratio="0.5">\n    <div class="modal-body">\n        <uc-wistia-video video-id="44fm0ll5du" aspect-169="true" play="true"></uc-wistia-video>\n    </div>\n</uc-modal-video>\n';
            return can.mustache('learn_signup_video_signup_video_mustache', template);
          });
